type BasicUserForURL = {
  id: string;
  slug: string;
  artist?: {
    id: string;
    slug: string;
  } | null;
};

/**
 * Gets the user's profile URL.
 *
 * @param user - user to get the URL for.
 * @returns - string of the profile URL.
 */
export function getUserUrl(user: BasicUserForURL) {
  return `${user.artist ? "/artist/" : "/user/"}${user.artist ? user.artist.slug : user.slug}`;
}
